export default "__VITE_ASSET__DEPbCxuX__"